const openModalButton = document.getElementById("openModal");
const submitButton = document.getElementById("submitButton");
const summaryModal = document.getElementById("summaryModal");
const courseScheduleSignupForm = document.getElementById(
    "courseScheduleSignupForm",
);

function handleFormSubmission(event) {
    event.preventDefault();

    if (courseScheduleSignupForm.checkValidity()) {
        document.body.classList.add("overflow-hidden");
        summaryModal.classList.remove("hidden");
        populateSummaryModal();
    } else {
        submitButton.click();
    }
}

courseScheduleSignupForm.addEventListener("submit", handleFormSubmission);

function validatePostcode(value) {
    const pattern = /^\d{5}$|^\d{2}-\d{3}$/;
    return pattern.test(value);
}

const postcodeInput = document.getElementById("id_postcode");
postcodeInput.addEventListener("input", () => {
    if (validatePostcode(postcodeInput.value)) {
        postcodeInput.setCustomValidity("");
    } else {
        postcodeInput.setCustomValidity(
            "Nieprawidłowy numer kodu pocztowego. Dozwolone formaty: 55-555 or 55555.",
        );
    }
});

function validatePhoneNumber(value) {
    const pattern = /^\+?\d{11}$|^\d{9}$|^\d{11}$/;
    return pattern.test(value);
}

const phoneInput = document.getElementById("id_phone");
phoneInput.addEventListener("input", () => {
    if (validatePhoneNumber(phoneInput.value)) {
        phoneInput.setCustomValidity("");
    } else {
        phoneInput.setCustomValidity(
            "Nieprawidłowy numer telefonu. Dozwolone formaty: 999888777, +48123456789, 48123456789.",
        );
    }
});

function validatePracticeNumber(value) {
    const pattern = /^\d{5,6}$/;
    return pattern.test(value);
}

const practiceNumberInput = document.getElementById(
    "id_professional_practice_number",
);
practiceNumberInput.addEventListener("input", () => {
    if (validatePracticeNumber(practiceNumberInput.value)) {
        practiceNumberInput.setCustomValidity("");
    } else {
        practiceNumberInput.setCustomValidity(
            "Nieprawidłowy numer wykonwywania zawodu. Dozwolone formaty: 54321 lub 654321.",
        );
    }
});

function validateTaxNumberDigitsLen(value) {
    const pattern = /^\d{10}$/;
    return pattern.test(value);
}

function validateTaxNumberChecksum(value) {
    if (!/^\d{10}$/.test(value)) {
        return false;
    }

    const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let checksum = 0;
    for (let i = 0; i < 9; i++) {
        checksum += Number.parseInt(value[i], 10) * weights[i];
    }
    const controlDigit = checksum % 11;

    if (controlDigit === 10) {
        return false;
    }
    return controlDigit === Number.parseInt(value[9], 10);
}

const taxInput = document.getElementById("id_tax_number");
taxInput.addEventListener("input", () => {
    if (validateTaxNumberDigitsLen(taxInput.value)) {
        taxInput.setCustomValidity("");
    } else {
        taxInput.setCustomValidity("NIP musi składać się dokładnie z 10 cyfr.");
        return;
    }
    if (validateTaxNumberChecksum(taxInput.value)) {
        taxInput.setCustomValidity("");
    } else {
        taxInput.setCustomValidity(
            "Niepoprawny numer NIP (błędna suma kontrolna).",
        );
    }
});

function populateSummaryModal() {
    populatePrimarySectionsSummary();
    populateAppartmentNumberSectionSummary();
    populateHiddableSectionsSummary();
    populateAdditionalInformationSummary();
    populateCompanyNameSummary();
    populateDietSummary();
    populateInstallmentsSummary();
    populateDiscountSummary();
}

openModalButton.addEventListener("click", handleFormSubmission);

submitButton.addEventListener("click", () => {
    if (summaryModal.classList.contains("hidden")) {
        return;
    }
    summaryModal.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");

    courseScheduleSignupForm.submit();
});

summaryModal.addEventListener("click", (event) => {
    if (event.target === summaryModal) {
        summaryModal.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
    }
});

for (const button of document.querySelectorAll(".close-modal-button")) {
    button.addEventListener("click", () => {
        summaryModal.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
    });
}

function populateInstallmentsSummary() {
    const installments_inputs = Array.from(
        document.querySelectorAll('[id^="id_installments_"]'),
    );
    for (let i = 0; i < installments_inputs.length; i++) {
        if (installments_inputs[i].checked === true) {
            const checked_installments_input_label = document.querySelector(
                `label[for="${installments_inputs[i].id}"]`,
            );
            document.getElementById("summary_id_installments").textContent =
                checked_installments_input_label.textContent;
            break;
        }
    }
}

function populateDietSummary() {
    const diet_inputs = Array.from(
        document.querySelectorAll('[id^="id_diet_"]'),
    );
    for (let i = 0; i < diet_inputs.length; i++) {
        if (diet_inputs[i].checked === true) {
            const checked_diet_input_label = document.querySelector(
                `label[for="${diet_inputs[i].id}"]`,
            );
            document.getElementById("summary_id_diet").textContent =
                checked_diet_input_label.textContent;
            break;
        }
    }
}

function populateCompanyNameSummary() {
    const company_name_input = document.getElementById("id_company_name");
    const company_name_summary = document.getElementById(
        "summary_id_company_name",
    );
    if (company_name_input.value) {
        company_name_summary.textContent = company_name_input.value;
    } else {
        const participant_first_name =
            document.getElementById("id_first_name").value;
        const participant_last_name =
            document.getElementById("id_last_name").value;
        company_name_summary.textContent = `${participant_first_name} ${participant_last_name}`;
    }
}

function populateAdditionalInformationSummary() {
    const additional_information_input = document.getElementById(
        "id_additional_information",
    );
    const additional_information_summary = document.getElementById(
        "summary_id_additional_information",
    );
    const additional_information_section = document.getElementById(
        "summary_id_additional_information_section",
    );

    if (additional_information_input.value) {
        additional_information_summary.textContent =
            additional_information_input.value;
        additional_information_section.classList.remove("hidden");
        additional_information_section.classList.add("summary-card-container");
    } else {
        additional_information_section.classList.add("hidden");
        additional_information_section.classList.remove(
            "summary-card-container",
        );
    }
}

function populateHiddableSectionsSummary() {
    const additional_inputs_ids = [
        "id_professional_practice_number",
        "id_tax_number",
    ];

    for (const id of additional_inputs_ids) {
        const input = document.getElementById(id);
        const summary = document.getElementById(`summary_${id}`);
        const section = document.getElementById(`summary_${id}_section`);

        if (input.value) {
            summary.textContent = input.value;
            section.classList.remove("hidden");
        } else {
            section.classList.add("hidden");
        }
    }
}

function populatePrimarySectionsSummary() {
    const inputs_ids = [
        "id_first_name",
        "id_last_name",
        "id_phone",
        "id_email",
        "id_street",
        "id_house_number",
        "id_postcode",
        "id_city",
        "id_company_name",
    ];
    for (const id of inputs_ids) {
        document.getElementById(`summary_${id}`).textContent =
            document.getElementById(id).value;
    }
}

function populateAppartmentNumberSectionSummary() {
    const id_apartment_number_input_value = document.getElementById(
        "id_apartment_number",
    ).value;
    const summary_id_apartment_number = document.getElementById(
        "summary_id_apartment_number",
    );
    if (id_apartment_number_input_value) {
        summary_id_apartment_number.textContent = `/${id_apartment_number_input_value}`;
    } else {
        summary_id_apartment_number.textContent = "";
    }
}

function parseAmount(value) {
    if (!value) {
        return null;
    }
    const normalized = value.replace(/[^0-9,.-]/g, "").replace(",", ".");
    const parsed = Number.parseFloat(normalized);
    return Number.isNaN(parsed) ? null : parsed;
}

function formatAmount(value, usesComma) {
    const fixed = value.toFixed(2).replace(/\.00$/, "");
    return usesComma ? fixed.replace(".", ",") : fixed;
}

function populateDiscountSummary() {
    const totalAmount = document.getElementById("summary_id_total_amount");
    const discountLine = document.getElementById("summary_id_discount_line");
    const regularPriceLine = document.getElementById(
        "summary_id_regular_price_line",
    );
    const discountDivider = document.getElementById(
        "summary_id_discount_divider",
    );
    const discountAmount = document.getElementById(
        "summary_id_discount_amount",
    );
    const discountRoot = document.getElementById("discount-code-field");
    const codeInput = document.getElementById("id_discount_code");

    if (!totalAmount || !discountLine || !discountAmount || !discountRoot) {
        return;
    }

    const baseText =
        totalAmount.dataset.basePrice || totalAmount.textContent || "";
    const baseValue = parseAmount(baseText);
    const discountText = discountRoot.dataset.discountAmount || "";
    const discountValue = parseAmount(discountText);
    const applied = discountRoot.dataset.discountApplied === "true";
    const usesComma = baseText.includes(",");

    if (!applied && codeInput?.value) {
        const validateUrl = discountRoot.dataset.validateUrl || "";
        const courseScheduleId = discountRoot.dataset.courseScheduleId || "";
        const code = codeInput.value.trim();
        if (validateUrl && code) {
            const body = new URLSearchParams({ code });
            if (courseScheduleId) {
                body.append("course_schedule_id", courseScheduleId);
            }
            const csrf = document.querySelector(
                'input[name="csrfmiddlewaretoken"]',
            );
            fetch(validateUrl, {
                method: "POST",
                headers: {
                    "Content-Type":
                        "application/x-www-form-urlencoded; charset=UTF-8",
                    "X-CSRFToken": csrf ? csrf.value : "",
                },
                body,
            })
                .then((response) => response.json())
                .then((data) => {
                    if (!data.success) {
                        return;
                    }
                    discountRoot.dataset.discountAmount = data.amount || "";
                    discountRoot.dataset.discountApplied = "true";
                    populateDiscountSummary();
                })
                .catch(() => undefined);
        }
    }

    if (!applied || baseValue === null || discountValue === null) {
        totalAmount.textContent = baseText.trim();
        discountLine.classList.add("hidden");
        regularPriceLine?.classList.add("hidden");
        discountDivider?.classList.add("hidden");
        return;
    }

    const totalValue = Math.max(baseValue - discountValue, 0);
    totalAmount.textContent = formatAmount(totalValue, usesComma);
    discountAmount.textContent = formatAmount(discountValue, usesComma);
    discountLine.classList.remove("hidden");
    regularPriceLine?.classList.remove("hidden");
    discountDivider?.classList.remove("hidden");
}

document.addEventListener("discount:changed", () => {
    if (!summaryModal.classList.contains("hidden")) {
        populateDiscountSummary();
    }
});
